import styled from 'styled-components';
import Field from '@lendi-ui/field';
import { RadioGroup } from '@lendi-ui/radio';

export const StyledField = styled(Field)`
  margin-top: 0 !important;
`;

export const StyledRadioGroup = styled(RadioGroup)`
  legend {
    display: none;
  }
  div {
    margin: 0;
  }
`;
